import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=3bfab63b"
import script from "./Surveys.vue?vue&type=script&lang=ts"
export * from "./Surveys.vue?vue&type=script&lang=ts"
import style0 from "./Surveys.vue?vue&type=style&index=0&id=3bfab63b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports